import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { OPD_CONST } from '../../regproperties/opd-static-properties';
import { MatSnackBar } from '@angular/material/snack-bar';
import { dupicatePatient } from '../../enums/configuration-modules.enum';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'lib-duplicate-patient-dialog',
  templateUrl: './duplicate-patient-dialog.component.html',
  styleUrl: './duplicate-patient-dialog.component.scss',
  providers: [DatePipe]
})
export class DuplicatePatientDialogComponent implements OnInit, OnDestroy {
  displayedColumns: string[] = OPD_CONST.regPatientDisplayColumns;
  dataSourcePatient: Patient[] = [];
  isNewPatientBtnShow: boolean = true;
  selectedId: string = "";
  constructor(
    public dialogRef: MatDialogRef<DuplicatePatientDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private snackBar: MatSnackBar,
    private datePipe: DatePipe
  ) { }

  ngOnInit(): void {
    if(!this.data.isNewBorn && this.data.from === dupicatePatient.identificationNo){
      this.isNewPatientBtnShow = false; 
      }else{
      this.isNewPatientBtnShow = true;
      }
    this.data.payload.forEach((element: any) => {
      this.dataSourcePatient.push({
        id: element?.id,
        fullName: element?.patientName ?? '',
        dob: this.datePipe.transform(element?.birthDate, 'dd-MM-yyyy') ?? '',
        gender: element?.gender?.display ?? '',
        mobileNumber: element?.mobileNumber?.mobileNumber ?? '',
        emailId: element?.telecom?.[0]?.value ?? '',
        identificationId: element?.primaryIdentifier?.value ?? ''
      });
    });
  }
  ngOnDestroy(): void {

  }
  onNoClick(value): void {
    this.dialogRef.close(value);
  }

  onRowClick(id: string) {
    this.selectedId = id;
  }
  confirmPatient() {
    if (this.selectedId) {
      this.dialogRef.close(this.selectedId);
    } else {
      this.snackBar.open('Please select a patient to proceed.', 'Validation', {
        duration: 2000,
        });
    }
  }
}
interface Patient {
  id: string;
  fullName: string;
  dob: string;
  gender: string;
  mobileNumber: string;
  emailId: string;
  identificationId: string;
}